import { Tabs } from "antd";
import Icon, { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import React from "react";
import { useState } from "react";
import "./ButtonsNav.scss";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import arrowBack from "../../../assets/namespace/icons/btnArrowBack";
import arrowForward from "../../../assets/namespace/icons/btnArrowForward";
import { IButtonsNavTypes } from "./ButtonsNav.types";

type PositionType = 'left' | 'right';

const BtnArrowBack = (props: Partial<CustomIconComponentProps>) =>
  <Icon component={arrowBack} {...props} />
const BtnArrowForward = (props: Partial<CustomIconComponentProps>) =>
  <Icon component={arrowForward} {...props} />




function ButtonsNavComponent({ TabsContent, className }: IButtonsNavTypes) {

  const [isActiveBack, setActiveBack] = useState(false);//false
  const [isActiveForward, setActiveForward] = useState(true);

  const [position] = useState<PositionType[]>(['left', 'right']);

  const [activeKey, setActiveKey] = useState('0');
  //TODO: improve!!!! 
  const onKeyChange = (key: string) => {
    if (key === 'back') {
      setActiveForward(true);
      if (activeKey != '0') {
        setActiveKey((parseInt(activeKey) - 1).toString());
        console.log('activeKey=', activeKey)
      }
      if ((parseInt(activeKey) - 1) == 0) {
        setActiveBack(false);
      }
    } else if (key === 'next') {
      if (parseInt(activeKey) < TabsContent.length - 1) {
        setActiveKey((parseInt(activeKey) + 1).toString());
        setActiveBack(true);
      }
      if (parseInt(activeKey) + 1 == TabsContent.length - 1) {
        setActiveForward(false);
      }
    } else {
      setActiveKey(key);
      if (key == '0') {
        setActiveBack(false);
      } else {
        setActiveBack(true);
      }
      if (key == (TabsContent.length - 1).toString()) {
        setActiveForward(false);
      } else {
        setActiveForward(true);
      }
    }
  };

  const OperationsSlot: Record<PositionType, React.ReactNode> = {
    left: <div onClick={() => onKeyChange('back')}>
      <ArrowLeftOutlined style={{ color: `${isActiveBack ? '#155892' : '#8FABC3'}`, cursor: 'pointer' }} />
    </div>,
    right: <div onClick={() => onKeyChange('next')}>
      <ArrowRightOutlined style={{ color: `${isActiveForward ? '#155892' : '#8FABC3'}`, cursor: 'pointer' }} />
    </div>
  };

  const slot = () => {
    if (position.length === 0) return null;

    return position.reduce(
      (acc, direction) => ({ ...acc, [direction]: OperationsSlot[direction] }),
      {},
    );
  };



  return (
    <div className="ButtonsNav">
      <Tabs
        type="line"
        centered={true}
        tabBarExtraContent={slot()}
        activeKey={activeKey}
        onChange={onKeyChange}
        className={className}
      >
        {
          TabsContent.map((item, index) => (
            <Tabs.TabPane key={index} tab={item.title}>
              <div style={{ marginTop: '15px' }}>
                <div className="pnlHeaderText">
                  {item.text}
                </div>
                <img src={item.contentImg || ''} alt={item.contentImg} style={{ width: '100%' }} />
              </div>
            </Tabs.TabPane>
          ))
        }
      </Tabs>
    </div>
  );
}

export default ButtonsNavComponent;
